import React from 'react'
import s from '../style'
export const Footer = () => {
  return (
    <div className={`${s.flexCenter} text-center sticky bottom-0 h-6 md:h-16 bg-black text-sm text-slate-400`}>
      copyright @2023 shanitpaul
    </div>
  )
}
